module.exports = __webpack_public_path__ + "web-application.3M6HmVP8.svg";